var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"diamond",style:({minWidth: _vm.getSize(), minHeight: _vm.getSize(), background: _vm.getCategoryColor(this.tagText)})})}
var staticRenderFns = []

export { render, staticRenderFns }